export const GLOBAL_ACCOUNT_DRAWER_LABELS = 'global.accountDrawer';
export const lblAccountDrawerLogout = 'lbl_accountDrawer_LogOut';
export const lblAccountDrawerSignOut = 'lbl_accountDrawer_signOut';
export const lblOverviewLogout = 'lbl_overview_logout';
export const lblAccountDrawerOthers = 'lbl_accountDrawer_others';
export const lblExpectedBy = 'lbl_expected_by';
export const lblAccountDashboardNoOrders = 'lbl_accoundDashboard_noOrders';

const GlobalAccountDrawerLabels = {
  global: {
    accountDrawer: {
      [lblAccountDrawerLogout]: 'Log Out',
      [lblAccountDrawerSignOut]: 'Sign Out',
      [lblOverviewLogout]: 'Log Out',
      [lblAccountDrawerOthers]: 'Orders',
      [lblExpectedBy]: 'Expected By',
      [lblAccountDashboardNoOrders]: 'No orders have been placed.',
    },
  },
};

export default GlobalAccountDrawerLabels;
